import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LayoutComponent } from './layout.component';
import { SidenavModule } from './components/sidenav/sidenav.module';
import { NavbarModule } from './components/navbar/navbar.module';
import { RouterModule, Routes } from '@angular/router';
import { PlatiOnlineModule } from '../components/plati-online/plati-online.module';
import { InterogariPlatiModule } from '../components/interogari-plati/interogari-plati.module';
import { TipuriTaxeNedebitateModule } from '../components/tipuri-taxe-nedebitate/tipuri-taxe-nedebitate.module';
import { TipuriAmenziModule } from '../components/tipuri-amenzi/tipuri-amenzi.module';
import { AmenziAchitateModule } from '../components/amenzi-achitate/amenzi-achitate.module';
import { TaxeNedebitateAchitateModule } from '../components/taxe-nedebitate-achitate/taxe-nedebitate-achitate.module';

const routes: Routes = [
    {
        path: 'dashboard',
        component: LayoutComponent,
    },
];

@NgModule({
    declarations: [LayoutComponent],
    imports: [
        CommonModule,
        RouterModule.forChild(routes),
        NavbarModule,
        SidenavModule,
        PlatiOnlineModule,
        InterogariPlatiModule,
        AmenziAchitateModule,
        TaxeNedebitateAchitateModule,
    ],
    exports: [RouterModule],
})
export class LayoutModule { }
